import { create } from 'zustand';

export type SummaryBreakdownStore = {
  isBreakdownOpen: boolean;
  handleBreakdownOpen: (isBreakdownOpen: boolean) => void;
};

export const useSummaryBreakdownStore = create<SummaryBreakdownStore>(set => ({
  isBreakdownOpen: false,
  handleBreakdownOpen: (isBreakdownOpen: boolean) => set({ isBreakdownOpen }),
}));
